import { render, staticRenderFns } from "./CPF.vue?vue&type=template&id=09b5615c"
import script from "./CPF.vue?vue&type=script&lang=js"
export * from "./CPF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports